import { render } from "./BasePage.vue?vue&type=template&id=91d2c96c&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"

import "./BasePage.vue?vue&type=style&index=0&id=91d2c96c&lang=css"
import "./BasePage.vue?vue&type=style&index=1&id=91d2c96c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d2c96c"]])

export default __exports__